module.exports = __webpack_public_path__ + "img/banner2.8350a8c6.png";